var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('Icons',{class:_vm.status,attrs:{"name":_vm.getIcons}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }